/** Resolve /u/:username when the segment contains @ (email-style usernames). */
export function publicProfileUsernameFromLocation(
  pathname: string,
  paramUsername?: string
): string {
  const match = pathname.match(/^\/u\/([^/]+)/);
  if (match?.[1]) {
    try {
      return decodeURIComponent(match[1]);
    } catch {
      return match[1];
    }
  }
  return paramUsername?.trim() ?? '';
}

export function shareTokenQuery(
  shareToken?: string | null,
  options?: { asRecruiterToken?: boolean }
): string {
  const token = shareToken?.trim();
  if (!token) return '';
  const param = options?.asRecruiterToken ? 'recruitertoken' : 'share_token';
  return `?${param}=${encodeURIComponent(token)}`;
}
